import type { FaireProductEntity } from "../../entity_types/product";

export const p_qbhs684zfn: FaireProductEntity = {
  token: "p_qbhs684zfn",
  type: "product",
  name: "18K Gold Plated Bar Style Light-blue Evil Eye Crystal Anklet",
  brandToken: "b_64gjnxjyb8",
  brandName: "Karrbear",
  imageUrl:
    "https://cdn.faire.com/fastly/ab77ca29b774597032a1edee4d19d42737546afdcdf3a350f08f921a51191d8e.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b5d4e1b880828d100a8a1866006698d327458a3730e744909c64aca49acd0cab.png",
    "https://cdn.faire.com/fastly/8d958c0b972f8cdcb8efa1a74725f42570526cba0df47166ae3aca5d7b2d8a05.png",
    "https://cdn.faire.com/fastly/abca5e2b4a5f59cc94588b7f9dd5e45a2359b7f6cce0de01d5208505c0483f2b.png",
  ],
  priceDollars: 6.93,
  description:
    "18K Gold Plated Anklet High Polish Finish Lifetime Guarantee Great Gift Add a hint of luxury to your ensemble with this anklet bracelet 10 Inches Perfect Length For an ankle bracelet Perfect accessory to wear to the beach a must have Made in Brazil",
  tags: [],
  msrpDollars: 13.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:16.381Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
